import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of, catchError, tap } from 'rxjs';

// Define interface for meter data
export interface MeterData {
  [key: string]: string;
}

// Interface for the entire response item
export interface SubsidyResponseItem {
  _id: string;
  aa_number: string;
  datetime: string;
  submit: string;
  submit_number: string;
  subsidy: SubsidyInfo[];
  uuid: string;
  vat_number: string;
}

// Interface for subsidy info
export interface SubsidyInfo {
    annual_turnover?: number;
    business_activity_code?: string;
    consumption_kwh?: number;
    deminimis_limit?: number;
    description: string;
    meter_id: string;
    supply_type?: string;
    total_subsidy: number;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MeterService {
  private readonly baseUrl = 'https://power4business.deddie.gr/api';
  private lastSelectedParams: HttpParams | null = null;

// Store the parameters for potential recall use
storeSelectedParams(params: HttpParams): void {
  this.lastSelectedParams = params;
  console.log('Stored parameters for future recall:', params.toString());
}

// Get the stored parameters for recall operations
getStoredParams(): HttpParams {
  if (!this.lastSelectedParams) {
    console.warn('No stored parameters found, returning empty params');
    return new HttpParams();
  }
  console.log('Retrieved stored parameters:', this.lastSelectedParams.toString());
  return this.lastSelectedParams;
}
  
  // Create a BehaviorSubject to store the selected meters
  private metersSource = new BehaviorSubject<MeterData>({});
  
  // Create an observable from the BehaviorSubject
  currentMeters = this.metersSource.asObservable();
  
  // Store validation results
  private validationResultsSource = new BehaviorSubject<SubsidyResponseItem[]>([]);

  constructor(private http: HttpClient) {}

  // Update the meters in the BehaviorSubject
  updateMeters(meters: MeterData): void {
    this.metersSource.next(meters);
  }

  // Validate selected meters
  validateSelectedMeters(params: HttpParams): Observable<any> {
    console.log('Validating selected meters with params:', params);
    
  return this.http.post<SubsidyResponseItem[]>(
    `${this.baseUrl}/subsidy`, 
    null,
    { params: params }
  ).pipe(
        tap(response => {
          console.log('RES METRITWN METERSER', response);
          this.validationResultsSource.next(response);
        }),
        catchError(error => {
          console.error('Meter validation failed:', error);
          return of([]);
        })
      );
  }

  // Get validation results
  getValidationResults(): Observable<SubsidyResponseItem[]> {
    return this.validationResultsSource.asObservable();
  }

  // Reset validation results
  resetValidationResults(): void {
    this.validationResultsSource.next([]);
  }

  // Clear all meters
  clearMeters(): void {
    this.metersSource.next({});
  }
}